<template>
  <f7-page name="home">
    <!-- Top Navbar -->
    <f7-navbar :sliding="false">
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding style="text-align:center;width:100%"><img src="https://vuejs.org/images/logo.png" height="20">{{title}}</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    
    </f7-navbar>
<f7-toolbar tabbar scrollable top>
   <f7-link v-for="(link, index) in menus.MenuCate" :key="index" :tab-link="`#tab-${index+1}`" :id="`tabz${index+1}`" :tab-link-active="index === 0">{{link.cateName}}</f7-link>
</f7-toolbar>
 <f7-tabs swipeable>
    <f7-tab v-for="(links, index) in menus.MenuList" :key="index" :id="'tab-'+parseInt(index+1)" class="page-content" style="padding-top:0px;"  @tab:show="slideOnTab1(index)"  :tab-active="index === 0">
      <f7-card class="demo-card-header-pic" v-for="(link,index2) in links[index]" :key="index2">
        <f7-card-header class="no-border"  style="padding:0"><a  :href="`/product/${index}/${index2}/`"><img v-bind:src="menus.ServerUrl+link.food_pic" width="100%"  /></a></f7-card-header>
        <f7-card-content>
          <p class="menu-title">{{link.menu_name}}</p>
          <p>{{link.menu_desc}}</p>
        </f7-card-content>
        <f7-card-footer>
          <f7-link>주문담기</f7-link>
          <f7-link>바로주문</f7-link>
        </f7-card-footer>
      </f7-card>
    </f7-tab>

  </f7-tabs>
    <!-- Page content-->
   
  </f7-page>
</template>

<script>
import slideOnTab from '../js/slideontab.js';

import Dom7 from 'Dom7';
var $$ =Dom7;

  export default {
    data: function () {

      return {
        product: "yoo",
        title:"menuplz",
          menus: this.$f7route.context.menus,
      };
    },
    methods: {
      slideOnTab1: function(idx){
   
      slideOnTab(idx);
      
   
      },
      test:function(){
      
         console.log("test!!!!!!!!!");
      }
    }
  };
</script>